<template>
  <div>
    <v-skeleton-loader
      v-show="playerLoader"
      :loading="playerLoader"
      type="card-avatar, table@2"
    ></v-skeleton-loader>

    <v-sheet
      v-show="!playerLoader"
      elevation="2"
      rounded
      color="#B9F6CA"
      class="mt-n2 py-4"
    >
      <!-- Player Profile card -->
      <v-card class="mx-auto my-5 px-4" max-width="1250" shaped>
        <v-col cols="1" md="1" sm="1">
          <v-icon color="blue darken-2" @click="backButton">
            mdi-arrow-left
          </v-icon>
        </v-col>

        <!--//* player detail -->
        <template v-if="fullStats.player">
          <v-row class="mx-2">
            <v-col
              cols="12"
              md="3"
              sm="4"
              class="text-sm-start text-md-start text-center"
            >
              <p class="caption font-weight-black">
                Height/Weight:
                <span class="font-weight-medium">
                  {{ fullStats.player.playerData.Height }}/{{
                    fullStats.player.playerData.Weight
                  }}lbs
                </span>
              </p>
              <p class="caption font-weight-black mt-n4">
                Date of Birth (Age):
                <span class="font-weight-medium">
                  {{ fullStats.player.playerData.BirthDate | dayFormatV2 }}
                </span>
              </p>
              <p class="caption font-weight-black mt-n4">
                Experience:
                <span v-if="SportId == '4'" class="font-weight-medium">
                  {{ fullStats.player.playerData.ExperienceString }}
                </span>
                <span v-else class="font-weight-medium">
                  {{ fullStats.player.profile.NbaExperience }}</span
                >
              </p>
              <p v-if="SportId == '4'" class="caption font-weight-black mt-n4">
                Drafted:
                <span class="font-weight-medium">
                  {{ fullStats.player.playerData.CollegeDraftYear }}/ RD.{{
                    fullStats.player.playerData.CollegeDraftRound
                  }}
                  /Pk.{{ fullStats.player.playerData.CollegeDraftPick }} ({{
                    fullStats.player.playerData.CollegeDraftTeam
                  }})
                </span>
              </p>
              <p class="caption font-weight-black mt-n4">
                College:
                <span class="font-weight-medium">{{
                  fullStats.player.profile.college
                }}</span>
              </p>
            </v-col>

            <!--//* player name -->
            <v-col cols="12" md="5" sm="8">
              <v-list-item three-line>
                <!-- //todo.. optimal way to set image -->
                <v-col md="2">
                  <v-img class="mx-auto" :src="fullStats.player.teamUrl" />
                </v-col>
                <!-- //todo.. optimal way to set image -->

                <!-- spacer -->
                <div class="mx-2"></div>
                <!-- spacer -->

                <v-list-item-avatar rounded size="65" color="#CFD8DC">
                  <v-img
                    class="mx-auto"
                    v-if="fullStats.player.photo"
                    :src="fullStats.player.photo"
                    max-height="55"
                    max-width="55"
                  />
                </v-list-item-avatar>

                <v-list-item-content class="px-1">
                  <v-list-item-title class="text-h6 mb-1 mt-2">
                    {{ fullStats.player.name }}
                    (#{{ fullStats.player.profile.jersy }}
                    {{ fullStats.player.profile.position }})
                  </v-list-item-title>
                  <div class="caption font-weight-black mb-2 mt-n2">
                    {{ fullStats.player.teamFullName }}
                  </div>

                  <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <!-- <div class="body-1 mt-n4 blue--text text-center mr-16 ml-n16"></div> -->
            </v-col>

            <!--//* player stats -->
            <!-- //!QB... -->
            <v-col
              v-if="fullStats.player.position == 'QB'"
              cols="12"
              class="mx-auto"
              md="4"
              sm="10"
            >
              <v-row justify="space-around">
                <!-- //? #1 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].PassingYards }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2"
                        >Yds</span
                      >
                    </template>
                    <span>Passing Yards</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #2 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].PassingYardsPerCompletion }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2 text-sm-center"
                        >Y/C</span
                      >
                    </template>
                    <span>Passing Yards per completion</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #3 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].PassingTouchdowns }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2 text-sm-center"
                        >TD</span
                      >
                    </template>
                    <span>Passing Touch down</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #4 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].PassingInterceptions }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2 text-sm-center"
                        >Int</span
                      >
                    </template>
                    <span>Passing Interception</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #5 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].RushingYards }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-2 ml-0 ml-sm-2"
                        >R/Yds</span
                      >
                    </template>
                    <span>Rushing Yards</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <!-- //!QB... -->

            <!-- //!RB... -->
            <v-col
              v-if="fullStats.player.position === 'RB'"
              class="mx-auto"
              cols="12"
              md="4"
              sm="10"
            >
              <v-row justify="center">
                <!-- //? #1 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].RushingAttempts }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2 text-sm-center"
                        >ATT</span
                      >
                    </template>
                    <span>Attempts</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #2 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].RushingYards }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-2 ml-0 ml-sm-2 text-sm-center"
                        >R/Yds</span
                      >
                    </template>
                    <span>Total Rushing Yards</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #3 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].RushingTouchdowns }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2 text-sm-center"
                        >TDs</span
                      >
                    </template>
                    <span>Touchdown</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #4 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].RushingYardsPerAttempt }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2 text-sm-center"
                        >AVG</span
                      >
                    </template>
                    <span>Avg per Rush Att</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #5 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].ReceivingTargets }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2 text-sm-center"
                        >TGT</span
                      >
                    </template>
                    <span>Targets</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <!-- //!RB... -->

            <!-- //!WR... -->
            <v-col
              v-if="fullStats.player.position === 'WR'"
              cols="12"
              class="mx-auto"
              md="4"
              sm="10"
            >
              <v-row justify="space-around">
                <!-- //? #1 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].Receptions }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2 text-sm-center"
                        >REC</span
                      >
                    </template>
                    <span>Receptions</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #2 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].ReceivingYards }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2 text-sm-center"
                        >Yds</span
                      >
                    </template>
                    <span>Total Yards</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #3 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].RushingTouchdowns }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2 text-sm-center"
                        >TDs</span
                      >
                    </template>
                    <span>Touchdown</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #4 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].ReceivingYardsPerReception }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2 text-sm-center"
                        >AVG</span
                      >
                    </template>
                    <span>Avg per Rec</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #5 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].ReceivingTargets }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2 text-sm-center"
                        >TGT</span
                      >
                    </template>
                    <span>Targets</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <!-- //!WR... -->

            <!-- //!TE... -->
            <v-col
              v-if="fullStats.player.position === 'TE'"
              cols="12"
              class="mx-auto"
              md="4"
              sm="10"
            >
              <v-row justify="space-around">
                <!-- //? #1 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].Receptions }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2"
                        >REC</span
                      >
                    </template>
                    <span>Receptions</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #2 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].ReceivingYards }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2"
                        >Yds</span
                      >
                    </template>
                    <span>Total Yards</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #3 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].RushingTouchdowns }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2"
                        >TDs</span
                      >
                    </template>
                    <span>Touchdown</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #4 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].ReceivingYardsPerReception }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2"
                        >AVG</span
                      >
                    </template>
                    <span>Avg per Rec</span>
                  </v-tooltip>
                </v-col>

                <!-- //? #5 -->
                <v-col cols="2" md="2" sm="2" class="mt-md-4">
                  <v-sheet
                    height="60"
                    width="60"
                    color="#57bc90"
                    elevation="1"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <span class="white--text body-1 font-weight-bold">
                      {{ season_stat.data[0].ReceivingTargets }}
                    </span>
                  </v-sheet>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-on="on"
                        v-bind="attrs"
                        class="caption ml-md-4 ml-0 ml-sm-2"
                        >TGT</span
                      >
                    </template>
                    <span>Targets</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <!-- //!TE... -->
            <!--//* player stats ends... -->
          </v-row>
        </template>

        <!-- player news... -->
        <!-- <v-row class="mx-2 mt-n4" v-if="fullStats.player">
          <v-col>
            <h3>NEWS</h3>
            <h4 class="body-1">
              {{ fullStats.player.lastallPlayernews[0].Title }}
            </h4>
            <span class="caption">
              {{ fullStats.player.lastallPlayernews[0].Updated | dayFormat }}
            </span>

            <p class="subtitle-2">
              {{ fullStats.player.lastallPlayernews[0].Content }}
            </p>
          </v-col>
        </v-row> -->
        <!-- player news... -->
      </v-card>
      <!-- Player Profile card ends-->

      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab href="#summary"> Summary </v-tab>

        <v-tab href="#scoring"> Fantasy Scoring </v-tab>

        <v-tab href="#stats"> FULL STATS </v-tab>

        <v-tab @change="fetchPlayerNews" href="#news"> NEWS </v-tab>
      </v-tabs>

      <v-tabs-items :value="tab" touchless>
        <!-- profile -->
        <!-- <v-tab-item value="profile">
          <profile-tab :Profile="fullStats.player.profile" />
        </v-tab-item> -->
        <!-- profile ends-->

        <template v-if="fullStats.player">
          <!--summary-->
          <v-tab-item value="summary">
            <Summary
              :stats="player_score"
              :Profile="fullStats.player.profile"
              :seasonStats="season_stat"
              :sportId="SportId"
            />
          </v-tab-item>

          <!-- scoring -->
          <v-tab-item value="scoring">
            <scoring
              :scoring="player_score"
              :sportId="SportId"
              :Profile="fullStats.player.profile"
            />
          </v-tab-item>

          <!-- full stats -->
          <v-tab-item value="stats">
            <full-stats
              :sportId="SportId"
              :Profile="fullStats.player.profile"
              :seasonStats="season_stat.data"
            />
          </v-tab-item>

          <!-- news... -->
          <v-tab-item value="news">
            <news
              :news="player_news.data"
              :sportId="SportId"
              :Profile="fullStats.player.profile"
            />
          </v-tab-item>
        </template>
      </v-tabs-items>
    </v-sheet>
  </div>
</template>

<script>
import Scoring from "@/components/Tabs/tabItems/PlayerDetails/Scoring.vue";

import FullStats from "@/components/Tabs/tabItems/PlayerDetails/FullStats.vue";

import News from "./tabItems/PlayerDetails/News.vue";

import { mapState } from "vuex";

import Summary from "@/components/Tabs/tabItems/PlayerDetails/Summary.vue";

export default {
  name: "PlayerDetail",
  components: { Summary, Scoring, FullStats, News },
  props: ["playerId", "SportId"],
  data: () => ({
    tab: null,
  }),

  mounted() {
    // this.fetchScoring();
    Promise.all([
      this.fetchPlayerScores(),
      this.fetchAllPlayerDetails(),
      this.fetchSeasonStats(),
    ]);
  },

  computed: {
    ...mapState("userModule", [
      "playerLoader",
      "player_score",
      "season_stat",
      "player_news",
      "fullStats",
    ]),
  },

  methods: {
    backButton() {
      this.$router.go(-1);
    },

    async fetchAllPlayerDetails() {
      let obj = {
        playerId: this.playerId,
        SportId: this.SportId,
      };
      await this.$store.dispatch("userModule/GetPlayerFullStats", obj);
    },

    async fetchPlayerScores() {
      let obj = {
        playerId: this.playerId,
        SportId: this.SportId,
      };
      await this.$store.dispatch("userModule/GetPlayerScore", obj);
    },

    async fetchSeasonStats() {
      let obj = {
        playerId: this.playerId,
        SportId: this.SportId,
      };
      await this.$store.dispatch("userModule/GetPlayerSeasonStats", obj);
    },

    async fetchPlayerNews() {
      let obj = {
        playerId: this.playerId,
        SportId: this.SportId,
      };
      await this.$store.dispatch("userModule/GetPlayerNews", obj);
    },
  },
};
</script>

<style scoped>
.basil {
  background-color: #fffbe6 !important;
}

.basil--text {
  color: #356859 !important;
}
</style>
